export function BrandFooter() {
  return (
    <div className="flex flex-col items-center gap-0.5">
      <a
        href="https://mensis.com.br"
        target="_blank"
        rel="noopener noreferrer"
        className="text-[10px] text-slate-400 hover:text-slate-600 transition-colors"
      >
        Mensis ®
      </a>
      <span className="text-[9px] text-slate-300 dark:text-slate-600">e9f52ae</span>
    </div>
  );
}
